<svg
    [attr.width]="size()"
    [attr.height]="size()"
    viewBox="0 0 8 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
        d="M1 13L7 7L1 1"
        stroke="#777777"
        stroke-linecap="round" />
</svg>
